import React, { FC, useState } from 'react'
import { AccordionProps } from './types'
import Font from '../../Core/Typography/Font/Font'
import Icon from '../../Core/Iconography/Icon/Icon'
import {
  AccordionWrapper,
  AccordionTitle,
  AccordionContent,
} from './Accordion.styles'
const Accordion: FC<AccordionProps> = props => {
  const [showContent, setShowContent] = useState(props.isOpen || false)
  return (
    <AccordionWrapper
      flexDirection='column'
      alignItems='stretch'
      margin={props.margin}
      gridArea={props.gridArea}
      maxWidth={props.maxWidth}
      bgColorTransparent={props.bgColorTransparent}
    >
      <AccordionTitle
        justifyContent='space-between'
        onClick={() => setShowContent(!showContent)}
      >
        <Font tag='h4'>{props.title}</Font>
        {showContent ? (
          <Icon name={props.arrowIcon ? 'chevron-up' : 'minus'} size='m' color={props.arrowIcon ? 'ultraViolet' : 'main'} />
        ) : (
          <Icon name={props.arrowIcon ? 'chevron-down' : 'plus'} size='m' color={props.arrowIcon ? 'ultraViolet' : 'main'} />
        )}
      </AccordionTitle>
      {showContent && <AccordionContent>{props.children}</AccordionContent>}
    </AccordionWrapper>
  )
}

Accordion.defaultProps = {
  isOpen: false,
}

export default Accordion
